import { InformationCircleIcon } from '@heroicons/react/24/outline';
import type { NotificationData } from '@mantine/notifications';

export const notificationStyleConfig = {
  icon: <InformationCircleIcon width={18} />
} as NotificationData;
